import React, { FunctionComponent } from 'react';
import { Platform, StyleSheet, Text, View } from 'react-native';
import FastImage, { FastImageSource } from 'react-native-fast-image';
import Chevron from '../../assets/icons/chevron.svg';
import TimerIcon from '../../assets/icons/timer-outline.svg';
import Theme from '../../theme';
import { LinearGradient } from '../../ui';
import { defaultScale } from '../../utils';
import { horizontalScrollConstants } from './HorizontalScroller';

interface IProps {
  imageHeight: number;
  imageWidth: number;
  header?: string;
  subHeading?: string;
  image: number | FastImageSource;
  applyHorizontalGradient?: boolean;
  applyBottomGradient?: boolean;
  applyImageGradient?: boolean;
  alert?: boolean;
}

const WorkoutSectionCardWithImageContentWrapper: FunctionComponent<IProps> = (
  {
    imageHeight,
    imageWidth,
    header,
    subHeading,
    image,
    applyHorizontalGradient = true,
    applyBottomGradient = true,
    applyImageGradient = false,
    alert = false,
  },
) => {
  const chevronSize = {
    width: defaultScale(18),
    height: defaultScale(18),
  };

  const imageAspectRatio = imageWidth / imageHeight;

  return (
    <>
      { applyHorizontalGradient && <LinearGradient
        colors={[Theme.GREY_MEDIUM, 'transparent']}
        start={{ x: 0, y: 0.5 }}
        end={{ x: 0.5, y: 0.5 }}
        style={[styles.gradient]}
        webClassName='workout-slider-card-horizontal-gradient'
      /> }

      <FastImage
        style={[styles.image, {
          height: horizontalScrollConstants.CARD_HEIGHT,
          width: imageAspectRatio * horizontalScrollConstants.CARD_HEIGHT,
        }]}
        resizeMode={FastImage.resizeMode.contain}
        source={image}
      />

      {applyImageGradient && <LinearGradient
        colors={[Theme.BLACK, 'transparent']}
        start={{ x: 0, y: 0 }}
        end={{ x: 0.4, y: 0 }}
        style={[styles.imageGradient,
          {
            width: imageAspectRatio * horizontalScrollConstants.CARD_HEIGHT,
            height: horizontalScrollConstants.CARD_HEIGHT,
          }]}
        webClassName='workout-slider-card-image-gradient'
      />}

      { applyBottomGradient && <LinearGradient
        colors={[Theme.BLACK, 'transparent']}
        start={{ x: 0.5, y: 1 }}
        end={{ x: 0.5, y: 0.5 }}
        style={[styles.gradient]}
        webClassName='workout-slider-card-bottom-gradient'
      />}

      {alert &&
        <View style={styles.alert}>
          <TimerIcon color={Theme.WHITE} width={defaultScale(25)} height={defaultScale(25)}></TimerIcon>
        </View>
      }

      <View>

        {header &&
          <View style={styles.headingContainer}>
            <Text style={[styles.heading, alert && { color: Theme.PRIMARY }]}>{header}</Text>
            <Chevron {...chevronSize} color={Theme.PRIMARY} />
          </View>
        }

      {subHeading &&
        <Text style={styles.subText}>{subHeading}</Text>
      }
      </View>
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: Theme.BLACK,
    flex: 1,
    justifyContent: 'flex-end',
    padding: defaultScale(20),
  },
  image: {
    position: 'absolute',
    right: -1,
    bottom: 0,
    top: 0,
  },
  heading: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
    paddingRight: defaultScale(5),
  },
  subText: {
    ...Theme.textStyle.bodyCopyMed,
    color: Theme.WHITE,
    zIndex: 5,
  },
  gradient: {
    ...StyleSheet.absoluteFillObject,
  },
  imageGradient: {
    right: 0,
    position: 'absolute',
  },
  headingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: defaultScale( Platform.OS === 'web' ? 0 : 10),
    zIndex: 5,
  },
  alert: {
    height: defaultScale(30),
    width: defaultScale(30),
    borderRadius: 5,
    backgroundColor: Theme.PRIMARY,
    position: 'absolute',
    top: defaultScale(15),
    left: defaultScale(20),
    zIndex: 5,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export default WorkoutSectionCardWithImageContentWrapper;
